import { createFileRoute } from '@tanstack/react-router';
import { ChannelAccountsPage } from '../../features/settings/components/channel-accounts-page.js';

export const Route = createFileRoute('/admin/channel-accounts')({ component: ChannelAccountsPage });
